import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ServerService } from "src/app/services/server.service";
import { ClipBoardService } from "../../../services/clipboard.service";

@Component({
  selector: "app-edit-media-plan-request",
  templateUrl: "./edit-media-plan-request.component.html",
  styleUrls: ["./edit-media-plan-request.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class EditMediaPlanRequestComponent implements OnInit {
  showComponentLoader = false;
  createMediaPlanRequestForm: FormGroup;
  isSubmit: boolean = false;
  btnStatus = true;
  authToken = localStorage.getItem("token");
  salePersonList: any;
  mmList: any;
  media_plan_request_data: any;
  quillConfig: any;
  htmlText: any;
  // configuration_values= [
  // "1 BHK",
  // "2 BHK",
  // "2.5 BHK",
  // "3 BHK",
  // "3.5 BHK",
  // "4 BHK",
  // "4.5 BHK",
  // "Office Spaces",
  // "Plots",
  // "Retail Shops",
  // "Studio Apartments",
  // "Villa"
  // ]
  allInfo: any;
  possessionDateRequired = false;
  mediaPlanRequestType = ["Quick CPL", "Detailed Media Plan"];
  allMediaPlanType: any;
  select1: any = [];
  typology_data = [];
  startingSizeVariable:any
  units = ["sq.ft.","sq.mtr.","sq.yd."]
  detailed_researched = false;
  minNumInWords: any = '';
  minValuesWithCommaSystem: any;
  minValuesWithComma:any;

  minNumInWordsBudget: any = '';
  minValuesWithCommaSystemBudget: any;
  minValuesWithCommaBudget:any;
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<EditMediaPlanRequestComponent>,
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.setCreate();
    // console.log(this.data)
    this.allInfo = this.data;
    // console.log(this.allInfo)
  }
  ngOnInit() {
    this.initializeEditor();
    this.getSP();
    this.getMM();
    this.getCommonData();
    // this.createMediaPlanRequestForm.get('budget').patchValue(this.CommaInNumber(String(this.data.budget),'budget'));
  }
  valueInWordsBudget(event) {
    // debugger;
    
    let values = Number(this.removeCommas(event))
// debugger
    // if (type == 'minValue') {

        this.minValuesWithCommaSystemBudget = values.toLocaleString('en-IN');

        var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
        var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        this.minValuesWithCommaBudget = this.removeCommas(event);
        if ((this.minValuesWithCommaBudget = this.minValuesWithCommaBudget.toString()).length > 9) return 'overflow';
        this.minValuesWithCommaBudget = ('000000000' + this.minValuesWithCommaBudget).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!this.minValuesWithCommaBudget) return; var str = '';
        str += (this.minValuesWithCommaBudget[1] != 0) ? (a[Number(this.minValuesWithCommaBudget[1])] || b[this.minValuesWithCommaBudget[1][0]] + ' ' + a[this.minValuesWithCommaBudget[1][1]]) + 'crore ' : '';
        str += (this.minValuesWithCommaBudget[2] != 0) ? (a[Number(this.minValuesWithCommaBudget[2])] || b[this.minValuesWithCommaBudget[2][0]] + ' ' + a[this.minValuesWithCommaBudget[2][1]]) + 'lakh ' : '';
        str += (this.minValuesWithCommaBudget[3] != 0) ? (a[Number(this.minValuesWithCommaBudget[3])] || b[this.minValuesWithCommaBudget[3][0]] + ' ' + a[this.minValuesWithCommaBudget[3][1]]) + 'thousand ' : '';
        str += (this.minValuesWithCommaBudget[4] != 0) ? (a[Number(this.minValuesWithCommaBudget[4])] || b[this.minValuesWithCommaBudget[4][0]] + ' ' + a[this.minValuesWithCommaBudget[4][1]]) + 'hundred ' : '';
        str += (this.minValuesWithCommaBudget[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(this.minValuesWithCommaBudget[5])] || b[this.minValuesWithComma[5][0]] + ' ' + a[this.minValuesWithComma[5][1]]) + 'only ' : '';
        this.minNumInWordsBudget = str;          
        // console.log(this.minNumInWords)
    // }
  }
  valueInWords(event) {
    // debugger;
    
    let values = Number(this.removeCommas(event))

    // if (type == 'minValue') {

        this.minValuesWithCommaSystem = values.toLocaleString('en-IN');

        var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
        var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        this.minValuesWithComma = this.removeCommas(event);
        if ((this.minValuesWithComma = this.minValuesWithComma.toString()).length > 9) return 'overflow';
        this.minValuesWithComma = ('000000000' + this.minValuesWithComma).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!this.minValuesWithComma) return; var str = '';
        str += (this.minValuesWithComma[1] != 0) ? (a[Number(this.minValuesWithComma[1])] || b[this.minValuesWithComma[1][0]] + ' ' + a[this.minValuesWithComma[1][1]]) + 'crore ' : '';
        str += (this.minValuesWithComma[2] != 0) ? (a[Number(this.minValuesWithComma[2])] || b[this.minValuesWithComma[2][0]] + ' ' + a[this.minValuesWithComma[2][1]]) + 'lakh ' : '';
        str += (this.minValuesWithComma[3] != 0) ? (a[Number(this.minValuesWithComma[3])] || b[this.minValuesWithComma[3][0]] + ' ' + a[this.minValuesWithComma[3][1]]) + 'thousand ' : '';
        str += (this.minValuesWithComma[4] != 0) ? (a[Number(this.minValuesWithComma[4])] || b[this.minValuesWithComma[4][0]] + ' ' + a[this.minValuesWithComma[4][1]]) + 'hundred ' : '';
        str += (this.minValuesWithComma[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(this.minValuesWithComma[5])] || b[this.minValuesWithComma[5][0]] + ' ' + a[this.minValuesWithComma[5][1]]) + 'only ' : '';
        this.minNumInWords = str;          
        // console.log(this.minNumInWords)
    // }
  }
  onContentChanged = (event) => {
    //console.log('onContentChanged ', event.html);

    // this.salePersonList = this.commentSalePersonList

    //var myString = '<p><span class="mention" data-index="0" data-denotation-char="@" data-id="1099" data-value="testSatol"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span>testSatol</span></span> <span class="mention" data-index="1" data-denotation-char="@" data-id="1087" data-value="inaam user12"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span>inaam user12</span></span> </p>';

    if (
      this.createMediaPlanRequestForm.value.htmlText != null &&
      this.createMediaPlanRequestForm.value.htmlText != ""
    ) {
      var regex = /data-id="([^"]+)"/g;
      var matches = event.html.match(regex);
      var dataIds = [];

      if (matches) {
        matches.map(function (match) {
          //return match.match(/data-id="([^"]+)"/)[1];
          dataIds.push(Number(match.match(/data-id="([^"]+)"/)[1]));
        });

        // this.dataIdsArr = dataIds

        var arr2Ids: any = new Set(dataIds.map((item) => item));
        //console.log(arr2Ids)

        var result = this.salePersonList.filter(
          (item) => !arr2Ids.has(item.id)
        );
        //console.log(result)

        this.salePersonList = result;
        //console.log(this.salePersonList)
        //console.log('data-ids:', dataIds);
      } else {
        //console.log('No data-id attributes found');
      }
    }

    this.createMediaPlanRequestForm.value.htmlText = event.html;
    // console.log(this.createMediaPlanRequestForm.value.htmlText);
    // if ((this.htmlText != null && this.htmlText != '') && (this.selectedCommentCategory != null && this.selectedCommentCategory != '')) {
    //   this.btnStatus = true
    // } else {
    //   this.btnStatus = false
    // }

    // let index = this.salePersonList.findIndex(user => user.id == event.html.id);

    // if (index != -1) {
    //   this.salePersonList.splice(index, 1);
    // } else {
    //   this.salePersonList.push(event.html)
    // }

    // console.log(this.salePersonList)
  };
  initializeEditor() {
    this.quillConfig = {
      //toolbar: '.toolbar',
      toolbar: {
        container: [
          ["bold", "italic", "underline", "strike"],
          ["blockquote", "code-block"],
          [{ header: 1 }, { header: 2 }],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ script: "sub" }, { script: "super" }],
          [{ indent: "-1" }, { indent: "+1" }],
          //[{ 'direction': 'rtl' }],                         // text direction
          [{ size: ["small", false, "large", "huge"] }],
          //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          //[{ 'color': [] }, { 'background': [] }],
          [{ font: [] }],
          [{ align: [] }],
          ["clean"],
          ["link"],
          //['link', 'image', 'video']
        ],
      },

      imageResize: {
        modules: ["Resize", "DisplaySize", "Toolbar"],
      },

      // mention: {
      //   allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
      //   mentionDenotationChars: ["@", "#"],
      //   source: (searchTerm, renderList, mentionChar) => {
      //     let values;

      //     if (mentionChar === "@") {
      //       //values = this.atValues;
      //       values = this.salePersonList;
      //     } else {
      //       //values = this.hashValues;
      //     }

      //     if (searchTerm.length === 0) {
      //       renderList(values, searchTerm);
      //     } else {
      //       const matches = [];
      //       for (var i = 0; i < values.length; i++)
      //         if (
      //           ~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
      //         )
      //           matches.push(values[i]);
      //       renderList(matches, searchTerm);
      //     }
      //   },
      // },

      "emoji-toolbar": true,
      "emoji-textarea": false,
      "emoji-shortname": true,

      keyboard: {
        bindings: {
          shiftEnter: {
            key: 13,
            shiftKey: true,
            handler: (range, context) => {
              // Handle shift+enter
              //console.log("shift+enter")
            },
          },
          enter: {
            key: 13,
            handler: (range, context) => {
              //console.log("enter");
              return true;
            },
          },
        },
      },
    };
  }
  getCommonData() {
    let url = "media_plan_request/common_data";
    this.serverService
      .getMediaPlanCommonData(url, this.authToken)
      .subscribe((data) => {
        this.media_plan_request_data = data.media_plan_request_data;
        // console.log(data);
      });
  }
  getMM() {
    this.showComponentLoader = true;

    let url = "/campaign_module/get_marketing_user";
    this.serverService.getSalePerson(url, this.authToken).subscribe(
      (data) => {
        this.mmList = data.data;

        //console.log(this.mmList)
        this.showComponentLoader = false;
      },
      (err) => {
        this.showComponentLoader = false;
        this.clipBoardService.checkServerError(err, this.authToken);
      }
    );
  }
  getSP() {
    this.showComponentLoader = true;

    let url = "/campaign_module/user_list?user_type=SalesAdmin";
    this.serverService.getSalePerson(url, this.authToken).subscribe(
      (data) => {
        this.salePersonList = data.data;
        //console.log(this.salePersonList)
        if (this.data.assigned_sales_manager_id) {
          const selectedIds = this.data.assigned_sales_manager_id
            .split(",")
            .map((id) => parseInt(id, 10));
          this.createMediaPlanRequestForm.get("msp").setValue(selectedIds);
        }
        this.showComponentLoader = false;
      },
      (err) => {
        this.showComponentLoader = false;
        this.clipBoardService.checkServerError(err, this.authToken);
      }
    );
  }
  userType(item) {
    return item.org_admin && !item.role
      ? "Vendor Admin"
      : !item.org_admin && !item.role
      ? "Vendor Standard User"
      : item.role;
  }
  // CommaInNumber(value: any, field_name: any) {
  //   if (!value) return;
  //   let rawValue = value.replace(/,/g, "");

  //   let number = Number(rawValue);
  //   if (isNaN(number)) return;
  //   let formattedValue = number.toLocaleString("en-IN");
  //   // console.log(typeof formattedValue);
  //   this.createMediaPlanRequestForm
  //     .get(field_name)
  //     .patchValue(formattedValue, { emitEvent: false });
  // }
  CommaInNumber(value: any, field_name: string, index?: number) {
    if(field_name == 'starting_price'){
      this.valueInWords(value)
      }
      if(field_name == 'budget'){
        this.valueInWordsBudget(value)
      }
    // this.valueInWords(value)
    if (!value) return;
    let rawValue = value.replace(/,/g, "");
    // console.log(this.numberToWordsIndian(rawValue))
    let number = Number(rawValue);
    if (isNaN(number)) return;
    let formattedValue = number.toLocaleString("en-IN");
    
    // this.removeCommas(this.numberToWordsIndian(number))
    if (
      index !== undefined &&
      this.createMediaPlanRequestForm.contains("mediaPlanTypologies")
    ) {
      const mediaPlanTypologies = this.mediaPlanTypologies;
      if (mediaPlanTypologies.controls[index]) {
        mediaPlanTypologies.controls[index]
          .get(field_name)
          .patchValue(formattedValue, { emitEvent: false });
      }
    } else {
      this.createMediaPlanRequestForm
        .get(field_name)
        .patchValue(formattedValue, { emitEvent: false });
    }
  }
  setCreate() {
    // this.data.assigned_sales_manager_id = this.data.assigned_sales_manager_id.split(',')
    // console.log(this.data.assigned_sales_manager_id)
    // this.select1 = this.data.typology.map((item)=> item.configuration)
    // console.log(this.select1)
    this.typology_data = this.data.typology;
    // console.log(this.typology_data)
    this.createMediaPlanRequestForm = this.fb.group({
      sp: [this.data.sales_person_id, Validators.required],
      msp: [null, Validators.required],
      am: [this.data.account_manager_id],
      projectName: [this.data.project_name, Validators.required],
      clientName: [this.data.client_name, Validators.required],
      configuration: [this.data.configuration, Validators.required],
      possession: [this.data.possession],
      starting_price: [this.data.starting_price, Validators.required],
      // budget: [this.data.budget, Validators.required],
      location: [this.data.location, Validators.required],
      // duration_in_days: [this.data.duration, Validators.required],
      cpl_need_for: [this.data.cpl_need_for, Validators.required],
      priority: [this.data.priority, Validators.required],
      assign_to: [this.data.assigned_to_id, Validators.required],
      startingSize:[this.data.size_type, Validators.required],
      htmlText: [this.data.remarks],
      is_detailed_research_required:[this.data.is_detailed_research_required != null?this.data.is_detailed_research_required:false],
      // plan_type: [this.data.plan_type, Validators.required],
      // client_type: [this.data.client_type, Validators.required],
      starting_size: ["",Validators.required],
      media_plan_request_type: [],
      units:[],
      // sample_flat_available: [this.data.creatives_available[0]],
      interior_elevation_creative_available: [this.data.creatives_available[0]],
      status: this.data.project_status
        ? this.data.project_status
        : "Ready To Move In",
    });
    // this.valueInWords(this.data.starting_price)
    this.detailed_researched =this.data.client_type == 'Builder'? true:false
    let unit = this.data.stating_size.split(" ");
    // console.log(unit[unit.length-1])
    this.createMediaPlanRequestForm.get("units").patchValue(unit[unit.length-1])
    this.createMediaPlanRequestForm.get("starting_size").patchValue(unit[unit.length-2])
    this.startingSizeVariable = this.data.size_type
    // body["client_type"] = this.createMediaPlanRequestForm.value.client_type
    // body["budget"] = this.createMediaPlanRequestForm.value.budget
    // body["plan_type"] = this.createMediaPlanRequestForm.value.plan_type
    // body["duration"] = this.createMediaPlanRequestForm.value.duration_in_days
    // body["creatives_available"] = creativeArr;
    // if (this.createMediaPlanRequestForm.get('media_plan_request_type').value != 'Quick CPL') {
    // this.createMediaPlanRequestForm.addControl('mediaPlanTypologies', this.fb.array([]));
    if (this.data.is_detailed_plan_required) {
      this.createMediaPlanRequestForm
        .get("media_plan_request_type")
        .patchValue("Detailed Media Plan");
      this.createMediaPlanRequestForm.addControl(
        "mediaPlanTypologies",
        this.fb.array([])
      );

      this.createMediaPlanRequestForm.addControl(
        "client_type",
        new FormControl(this.data.client_type, Validators.required)
      );
      this.createMediaPlanRequestForm.addControl(
        "budget",
        new FormControl(this.data.budget, Validators.required)
      );

      this.createMediaPlanRequestForm.addControl(
        "is_detailed_research_required",
        new FormControl(false)
      );
      this.createMediaPlanRequestForm.addControl(
        "plan_type",
        new FormControl(this.data.plan_type, Validators.required)
      );
      this.createMediaPlanRequestForm.addControl(
        "duration_in_days",
        new FormControl(this.data.duration, Validators.required)
      );
      this.createMediaPlanRequestForm.addControl(
        "sample_flat_available",
        new FormControl(this.data.creatives_available[0])
      );
      this.createMediaPlanRequestForm.addControl(
        "interior_elevation_creative_available",
        new FormControl(this.data.creatives_available[1])
      );
      // debugger;
      const selectedConfigurations = this.data.typology || [];
      const currentFormArray = this.mediaPlanTypologies;

      while (currentFormArray.length > 0) {
        currentFormArray.removeAt(0);
      }

      selectedConfigurations.forEach((config: any) => {
        const exists = currentFormArray.controls.some(
          (group: any) =>
            group.get("configuration").value === config.configuration.value
        );

        if (!exists) {
          currentFormArray.push(
            this.fb.group({
              configuration: [config.configuration, Validators.required],
              price: [config.price, Validators.required],
            })
          );
        }
      });

      this.allMediaPlanType = selectedConfigurations;
      this.select1 = selectedConfigurations;
    } else {
      this.createMediaPlanRequestForm
        .get("media_plan_request_type")
        .patchValue("Quick CPL");
    }
    if (this.createMediaPlanRequestForm.value.project_status) {
      if (
        this.createMediaPlanRequestForm.value.project_status.toLowerCase() ==
        "under construction"
      ) {
        this.possessionDateRequired = true;
        this.createMediaPlanRequestForm
          .get("possession")
          .setValidators([Validators.required]);
      } else {
        this.possessionDateRequired = false;
        this.createMediaPlanRequestForm.get("possession").clearValidators();
      }
      this.createMediaPlanRequestForm
        .get("possession")
        .updateValueAndValidity();
    }
    // this.createMediaPlanRequestForm.get('budget').patchValue(this.CommaInNumber(this.data.budget,'budget'));
    // this.CommaInNumber(this.data.budget, 'budget');
  }
  get mediaPlanTypologies(): FormArray {
    return this.createMediaPlanRequestForm.get(
      "mediaPlanTypologies"
    ) as FormArray;
  }
  mediaTypeChange(event: any) {
    // console.log(event.value)
    if (
      this.createMediaPlanRequestForm.get("media_plan_request_type").value !=
      "Quick CPL"
    ) {
      this.createMediaPlanRequestForm.addControl(
        "mediaPlanTypologies",
        this.fb.array([])
      );
      this.createMediaPlanRequestForm.addControl(
        "client_type",
        new FormControl(null, Validators.required)
      );
      this.createMediaPlanRequestForm.addControl(
        "budget",
        new FormControl("", Validators.required)
      );
      this.createMediaPlanRequestForm.addControl(
        "plan_type",
        new FormControl(null, Validators.required)
      );
      this.createMediaPlanRequestForm.addControl(
        "duration_in_days",
        new FormControl("", Validators.required)
      );
      this.createMediaPlanRequestForm.addControl(
        "sample_flat_available",
        new FormControl(this.data.creatives_available[0])
      );
      this.createMediaPlanRequestForm.addControl(
        "interior_elevation_creative_available",
        new FormControl(this.data.creatives_available[1])
      );
      // this.createMediaPlanRequestForm.removeControl('client_type');
      // if (this.createMediaPlanRequestForm.contains('mediaPlanTypologies')) {
      //   this.createMediaPlanRequestForm.removeControl('mediaPlanTypologies');
      // }
      this.createMediaPlanRequestForm.get("media_plan_request_type")
      .patchValue("Detailed Media Plan");
     
      
    } else {
      this.createMediaPlanRequestForm.removeControl("client_type");
      this.createMediaPlanRequestForm.removeControl("is_detailed_research_required");
      this.createMediaPlanRequestForm.removeControl("budget");
      this.createMediaPlanRequestForm.removeControl("plan_type");
      this.createMediaPlanRequestForm.removeControl("duration_in_days");
      this.createMediaPlanRequestForm.get("media_plan_request_type")
        // .patchValue("Detailed Media Plan");
        // .get("media_plan_request_type")
        .patchValue("Quick CPL");
    }
    this.createMediaPlanRequestForm.get("configuration").reset();
    //  this.createMediaPlanRequestForm.get('mediaPlanTypologies').reset();
    const mediaPlanTypologies = this.createMediaPlanRequestForm.get(
      "mediaPlanTypologies"
    ) as FormArray;
    // Clear all controls
    while (mediaPlanTypologies.length !== 0) {
      mediaPlanTypologies.removeAt(0);
    }

    this.createMediaPlanRequestForm.get("configuration").setValue([]);
  }
  // addMediaPlanTypologies(event: any) {
  //   debugger;
  //   if (this.createMediaPlanRequestForm.contains('mediaPlanTypologies') &&
  //       this.createMediaPlanRequestForm.get('media_plan_request_type').value !== 'Quick CPL')  {

  //     const selectedConfigurations = event.value || [];
  //     const currentFormArray = this.mediaPlanTypologies;

  //     // while (currentFormArray.length > 0) {
  //     //   currentFormArray.removeAt(0);
  //     // }

  //     selectedConfigurations.forEach((config: string) => {
  //       currentFormArray.push(this.fb.group({
  //         configuration: [config, Validators.required],
  //         price: ['', Validators.required]
  //       }));
  //     });

  //     this.allMediaPlanType = selectedConfigurations;
  //     this.select1 = selectedConfigurations; // Update select1 if needed
  //   }
  // }
  // addMediaPlanTypologies(event:any) {
  //   debugger;
  //   const selectedConfigurations = this.data.typology;
  //   const currentFormArray = this.mediaPlanTypologies;

  //   selectedConfigurations.forEach((config: any) => {
  //     const exists = currentFormArray.controls.some((group: any) =>
  //       group.get('configuration').value == config.configuration
  //     );

  //     if (!exists) {
  //       currentFormArray.push(this.fb.group({
  //         configuration: [config.configuration, Validators.required],
  //         price: [config.price, Validators.required]
  //       }));
  //     }
  //   });

  //   this.allMediaPlanType = selectedConfigurations;
  //   this.select1 = selectedConfigurations;
  // }

  // addMediaPlanTypologies(event: any) {
  //   if (this.createMediaPlanRequestForm.contains('mediaPlanTypologies') &&
  //       this.createMediaPlanRequestForm.get('media_plan_request_type').value !== 'Quick CPL') {
  //     const selectedConfigurations = event.value || []; // Use event.value from mat-select
  //     const currentFormArray = this.mediaPlanTypologies;

  //     // Clear existing form array to reflect current selection
  //     // while (currentFormArray.length > 0) {
  //     //   currentFormArray.removeAt(0);
  //     // }

  //     // Add only unique configurations
  //     selectedConfigurations.forEach((config: string) => {
  //       const exists = currentFormArray.controls.some((group: any) =>
  //         group.get('configuration').value === config
  //       );

  //       if (!exists) {
  //         currentFormArray.push(this.fb.group({
  //           configuration: [config, Validators.required],
  //           price: ['', Validators.required] // Price can be edited manually
  //         }));
  //       }
  //     });

  //     this.allMediaPlanType = selectedConfigurations;
  //     this.select1 = selectedConfigurations;
  //   }
  // }

  addMediaPlanTypologies(event: any) {
    if (
      this.createMediaPlanRequestForm.contains("mediaPlanTypologies") &&
      this.createMediaPlanRequestForm.get("media_plan_request_type").value !==
        "Quick CPL"
    ) {
      const selectedConfigurations = event.value || []; // Use event.value from mat-select
      const currentFormArray = this.mediaPlanTypologies;
      const typologyMap = new Map(
        this.data.typology.map((item) => [item.configuration, item.price]) || []
      );

      while (currentFormArray.length > 0) {
        currentFormArray.removeAt(0);
      }

      if (selectedConfigurations.length === 0) {
        currentFormArray.push(
          this.fb.group({
            configuration: ["", Validators.required],
            price: ["", Validators.required],
          })
        );
      } 
      else {
        // debugger;
        selectedConfigurations.forEach((config: string) => {
          let existingPrice: any = "";
          const existingGroup = currentFormArray.controls.find((group: any) => {
            return (
              group instanceof FormGroup &&
              group.get("configuration").value === config
            );
          });
          if (existingGroup instanceof FormGroup) {
            existingPrice = existingGroup.get("price").value || "";
          } else {
            existingPrice = typologyMap.get(config) || "";
          }
          currentFormArray.push(
            this.fb.group({
              configuration: [config, Validators.required],
              price: [existingPrice, Validators.required],
            })
          );
        });
      }

      this.allMediaPlanType = selectedConfigurations;
      this.select1 = selectedConfigurations.map((config) => ({
        configuration: config,
        price:
          currentFormArray.controls
            .find(
              (group: any) =>
                group instanceof FormGroup &&
                group.get("configuration").value === config
            )
            .get("price").value ||
          typologyMap.get(config) ||
          "",
      }));
    }
  }
  statusChange(event: any) {
    if (
      event.value.toLowerCase() == "under construction" ||
      event.value.toLowerCase() == "pre launch"
    ) {
      this.possessionDateRequired = true;
      this.createMediaPlanRequestForm
        .get("possession")
        .setValidators([Validators.required]);
    } else {
      this.possessionDateRequired = false;
      this.createMediaPlanRequestForm.get("possession").clearValidators();
    }
    this.createMediaPlanRequestForm.get("possession").updateValueAndValidity();
  }
  save() {
    this.showComponentLoader = true;
    this.isSubmit = true;
    this.btnStatus = true;

    if (this.createMediaPlanRequestForm.invalid) {
      this.showComponentLoader = false;
      return;
    }
    let creativeArr = [];
    creativeArr.push(
      this.createMediaPlanRequestForm.value.sample_flat_available
    );
    creativeArr.push(
      this.createMediaPlanRequestForm.value
        .interior_elevation_creative_available
    );

    this.createMediaPlanRequestForm.value.budget = this.removeCommas(
      this.createMediaPlanRequestForm.value.budget
    );
    this.createMediaPlanRequestForm.value.starting_price = this.removeCommas(
      this.createMediaPlanRequestForm.value.starting_price
    );
    this.createMediaPlanRequestForm.value.duration_in_days = this.removeCommas(
      this.createMediaPlanRequestForm.value.duration_in_days
    );
    this.createMediaPlanRequestForm.value.starting_size = this.removeCommas(
      this.createMediaPlanRequestForm.value.starting_size
    );
    let tempSalesReportingManager =
      this.createMediaPlanRequestForm.value.msp.join(", ");
      let starting_size  =
      this.removeCommas(this.createMediaPlanRequestForm.value.starting_size) + " "+ this.createMediaPlanRequestForm.value.units
    let body = {
      sales_person_id: this.createMediaPlanRequestForm.value.sp,
      assigned_sales_manager_id: tempSalesReportingManager,
      account_manager_id: this.createMediaPlanRequestForm.value.am,
      project_name: this.createMediaPlanRequestForm.value.projectName,
      client_name: this.createMediaPlanRequestForm.value.clientName,
      possession: this.createMediaPlanRequestForm.value.possession,
      starting_price: this.createMediaPlanRequestForm.value.starting_price,
      // budget: this.createMediaPlanRequestForm.value.budget,
      location: this.createMediaPlanRequestForm.value.location,
      // duration: this.createMediaPlanRequestForm.value.duration_in_days,
      cpl_need_for: this.createMediaPlanRequestForm.value.cpl_need_for,
      priority: this.createMediaPlanRequestForm.value.priority,
      // plan_type: this.createMediaPlanRequestForm.value.plan_type,
      // client_type: this.createMediaPlanRequestForm.value.client_type,
      // stating_size: this.createMediaPlanRequestForm.value.starting_size,
      stating_size: starting_size,
      size_type:this.createMediaPlanRequestForm.value.startingSize,
      remarks: this.createMediaPlanRequestForm.value.htmlText,
      is_detailed_plan_required: this.createMediaPlanRequestForm.value
        .media_plan_request_type != 'Quick CPL'
        ? true
        : false,
      assigned_to_id: this.createMediaPlanRequestForm.value.assign_to,
      // creatives_available: creativeArr,
      configuration: this.createMediaPlanRequestForm.value.configuration,
      project_status: this.createMediaPlanRequestForm.value.status,
    };

    if (
      this.createMediaPlanRequestForm.value.media_plan_request_type !=
      "Quick CPL"
    ) 
    {
      this.typology_data = [];
      this.mediaPlanTypologies.controls.forEach((element: any) => {
        this.typology_data.push({
          price: element.value.price,
          configuration: element.value.configuration,
        });
      });

      body["client_type"] = this.createMediaPlanRequestForm.value.client_type;
      body["is_detailed_research_required"] = this.createMediaPlanRequestForm.value.is_detailed_research_required;
      body["budget"] = this.createMediaPlanRequestForm.value.budget;
      body["plan_type"] = this.createMediaPlanRequestForm.value.plan_type;
      body["duration"] = this.createMediaPlanRequestForm.value.duration_in_days;
      body["creatives_available"] = creativeArr;
      body["typology"] = this.typology_data;
    }
    else{
      body["typology"] = []
    }
    let url = this.data.id;

    this.serverService
      .updateMediaPlanRequest(url, body, this.authToken)
      .subscribe(
        (data) => {
          this.isSubmit = false;
          this.btnStatus = false;
          this.showComponentLoader = false;
          this.clipBoardService.showMessgeInText(
            "Media Plan Request Updated Successfully",
            "success-snackbar"
          );
          this.dialogRef.close(data);
        },
        (err) => {
          this.btnStatus = false;
          this.showComponentLoader = false;
          this.clipBoardService.checkServerError(err, this.authToken);
        }
      );
  }
  clientToggle(event:any){

    this.detailed_researched = event.value == 'Builder'?true:false

  }
  close() {
    this.dialogRef.close();
  }
  startingSizeToggle(event:any){
    // console.log(event.value)
    this.startingSizeVariable =  this.createMediaPlanRequestForm.get("startingSize").value;
    // console.log(this.startingSizeVariable)
  }
  get fCreate() {
    return this.createMediaPlanRequestForm.controls;
  }

  removeCommas(value: any): string {
    if (!value) return "0";
    return typeof value === "string"
      ? value.replace(/,/g, "")
      : value.toString();
  }
  numberToWordsIndian(num: any): string {
    // debugger;
    num = Number(num);
    // console.log(num)
    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    if (num === 0) return "Zero";

    function convertLessThanThousand(n: number): string {
      let word = "";
      if (n >= 100) {
        word += a[Math.floor(n / 100)] + " Hundred ";
        n %= 100;
      }
      if (n >= 20) {
        word += b[Math.floor(n / 10)] + " ";
        n %= 10;
      }
      if (n > 0) {
        word += a[n] + " ";
      }
      return word.trim();
    }

    let word = "";
    const crore = Math.floor(num / 10000000);
    num %= 10000000;
    const lakh = Math.floor(num / 100000);
    num %= 100000;
    const thousand = Math.floor(num / 1000);
    const remaining = num % 1000;

    if (crore > 0) {
      word += convertLessThanThousand(crore) + " Crore ";
    }
    if (lakh > 0) {
      word += convertLessThanThousand(lakh) + " Lakh ";
    }
    if (thousand > 0) {
      word += convertLessThanThousand(thousand) + " Thousand ";
    }
    if (remaining > 0) {
      word += convertLessThanThousand(remaining);
    }

    return word.trim() || "Zero";
  }
  isPriceValid(priceValue: string): boolean {
    if (!priceValue) return false;
    const rawValue = priceValue.replace(/,/g, "");
    return !isNaN(Number(rawValue)) && rawValue !== "";
  }

  getPriceInWords(priceValue: string): string {
    if (!this.isPriceValid(priceValue)) return "Invalid Number";
    const rawValue = priceValue.replace(/,/g, "");
    return this.numberToWordsIndian(Number(rawValue));
  }
}